// extracted by mini-css-extract-plugin
export var youtubePlayer = "YouTubeVideo-module--youtubePlayer--28371";